export const palettes: IPalettes = {
  white: {
    id: 'white',
    prevId: '12342167-279f-4db1-9d45-70f4e489e804',
    name: 'White',
    materials: {
      '0': {
        id: '0',
        tint: '#FFFFFF',
        metalness: 0,
        roughness: 0.5,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#FFFFFF',
        metalness: 0,
        roughness: 0.5,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#FFFFFF',
        metalness: 0,
        roughness: 0.5,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#FFFFFF',
        metalness: 0,
        roughness: 1,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
    },
  },
  mahogany: {
    id: 'mahogany',
    prevId: '01942167-279f-4db1-9d45-70f4e489e804',
    name: 'Mahogany',
    materials: {
      '0': {
        id: '0',
        tint: '#723E1C',
        metalness: 0,
        roughness: 0.8,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#7C4622',
        metalness: 0,
        roughness: 0.8,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#B9B9B9',
        metalness: 1,
        roughness: 0.3,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#F5EEE5',
        metalness: 0,
        roughness: 1,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
    },
  },
  farming: {
    id: 'farming',
    prevId: '07e5f24e-242b-4a27-8807-068a187bd77c',
    name: 'Farming',
    materials: {
      '0': {
        id: '0',
        tint: '#D90416',
        metalness: 0,
        roughness: 0.5,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#1F4E8C',
        metalness: 0,
        roughness: 0.5,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#595959',
        metalness: 0,
        roughness: 0.5,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#AED3F2',
        metalness: 0,
        roughness: 0.5,
        specular: 0.5,
        emission: 0,
        transparency: 0.5,
      },
    },
  },
  sticks_and_stones: {
    id: 'sticks_and_stones',
    prevId: '15616a37-8a74-40b6-8a2a-b00adbb32d84',
    name: 'Sticks and Stones',
    materials: {
      '0': {
        id: '0',
        tint: '#4E351B',
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#6A4927',
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#7F7F7F',
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#949494',
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
    },
  },
  salamandra_metalic: {
    id: 'salamandra_metalic',
    prevId: '2eb1767e-7e6b-4528-93c0-aaf6ffa26fbe',
    name: 'Salamandra Metalic',
    materials: {
      '0': {
        id: '0',
        tint: '#6B6B6B',
        metalness: 0,
        roughness: 0.45,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#CFCFCF',
        metalness: 1,
        roughness: 0.45,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#FF9C57',
        metalness: 1,
        roughness: 0.45,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#FF3751',
        metalness: 1,
        roughness: 0.45,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
    },
  },
  fireinternal: {
    id: 'fireinternal',
    prevId: '761bd850-8253-4e21-8e8a-5bf6fe5ac7ac',
    materials: {
      '0': {
        id: '0',
        emission: 0.5,
        metalness: 0,
        roughness: 1,
        specular: 0,
        tint: '#FF6A00',
        transparency: 1,
      },
      '1': {
        id: '1',
        emission: 0.5,
        metalness: 0,
        roughness: 1,
        specular: 0,
        tint: '#FF3808',
        transparency: 1,
      },
      '2': {
        id: '2',
        emission: 0.5,
        metalness: 0,
        roughness: 1,
        specular: 0,
        tint: '#DB0A19',
        transparency: 1,
      },
      '3': {
        id: '3',
        emission: 0.5,
        metalness: 0,
        roughness: 1,
        specular: 0,
        tint: '#FF8E04',
        transparency: 1,
      },
    },
    name: 'FireInternal',
  },
  'sci-fi_radiant_blue': {
    id: 'sci-fi_radiant_blue',
    prevId: '3a79c5d7-ba42-4025-8417-78e453aeda72',
    name: 'Sci-fi Radiant Blue',
    materials: {
      '0': {
        id: '0',
        tint: '#818181',
        metalness: 1,
        roughness: 0.65,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#ABABAB',
        metalness: 1,
        roughness: 0.65,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#222222',
        metalness: 1,
        roughness: 0.3,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#1B79BA',
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        emission: 1,
        transparency: 0.8,
      },
    },
  },
  farming_2: {
    id: 'farming_2',
    prevId: '3a7a1522-0eaa-47b0-9966-6e915f8a7c40',
    materials: {
      '0': {
        id: '0',
        emission: 0,
        metalness: 0,
        roughness: 0.9,
        specular: 0.5,
        tint: '#D64142',
        transparency: 1,
      },
      '1': {
        id: '1',
        emission: 0,
        metalness: 0,
        roughness: 0.9,
        specular: 0.5,
        tint: '#919191',
        transparency: 1,
      },
      '2': {
        id: '2',
        emission: 0,
        metalness: 0,
        roughness: 0.9,
        specular: 0.5,
        tint: '#FCFCFC',
        transparency: 1,
      },
      '3': {
        id: '3',
        emission: 0,
        metalness: 0,
        roughness: 0.3,
        specular: 0.5,
        tint: '#AED3F2',
        transparency: 0.5,
      },
    },
    name: 'Farming 2',
  },
  pink_vision: {
    id: 'pink_vision',
    prevId: '3cb4f58e-ed1c-4bdc-9ed0-441679f6d84c',
    name: 'Pink Vision',
    materials: {
      '0': {
        id: '0',
        tint: '#FF0081',
        metalness: 0,
        roughness: 0.3,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#FF48A5',
        metalness: 0,
        roughness: 0.3,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#FFD6EB',
        metalness: 0,
        roughness: 0.3,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#FFAED7',
        metalness: 0,
        roughness: 0.3,
        specular: 0.5,
        emission: 0,
        transparency: 0.8,
      },
    },
  },
  farming_machinery: {
    id: 'farming_machinery',
    prevId: '3cd1b3ec-0ed4-4dda-b009-dc11090a73c4',
    name: 'Farming Machinery',
    materials: {
      '0': {
        id: '0',
        tint: '#067022',
        metalness: 1,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#919191',
        metalness: 1,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#222222',
        metalness: 0,
        roughness: 1,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#AED3F2',
        metalness: 0,
        roughness: 0.1,
        specular: 0.5,
        emission: 0,
        transparency: 0.8,
      },
    },
  },
  plastic: {
    id: 'plastic',
    prevId: '3da5a83a-a927-44b0-9a2e-02a1da5c4f15',
    name: 'Plastic',
    materials: {
      '0': {
        id: '0',
        tint: '#FFC28B',
        metalness: 0,
        roughness: 0.4,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#FF9463',
        metalness: 0,
        roughness: 0.4,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#FE6D4E',
        metalness: 0,
        roughness: 0.4,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#FF5342',
        metalness: 0,
        roughness: 0.4,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
    },
  },
  machinery: {
    id: 'machinery',
    prevId: '44032148-0d90-4fa1-8677-9df1706c0321',
    name: 'Machinery',
    materials: {
      '0': {
        id: '0',
        tint: '#F2A007',
        metalness: 1,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#F2C230',
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#222222',
        metalness: 0,
        roughness: 0.3,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#F27405',
        metalness: 0,
        roughness: 0.5,
        specular: 0.5,
        emission: 1,
        transparency: 0.8,
      },
    },
  },
  salamandra: {
    id: 'salamandra',
    prevId: '4470f946-d908-4dbe-b6a0-2e0c054b4cba',
    name: 'Salamandra',
    materials: {
      '0': {
        id: '0',
        tint: '#6B6B6B',
        metalness: 1,
        roughness: 0.45,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#C0443C',
        metalness: 0,
        roughness: 0.45,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#E3714A',
        metalness: 0,
        roughness: 0.45,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#ED914E',
        metalness: 0,
        roughness: 0.45,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
    },
  },
  'sci-fi_white_orange': {
    id: 'sci-fi_white_orange',
    prevId: '50e6869e-211b-49dd-b9a2-874e8c30e4bb',
    name: 'Sci-Fi White Orange',
    materials: {
      '0': {
        id: '0',
        tint: '#E9E9E9',
        metalness: 0.3,
        roughness: 0.3,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#FFFBFB',
        metalness: 0.9,
        roughness: 0.5,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#F2843E',
        metalness: 0.4,
        roughness: 0.4,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#2E2E2E',
        metalness: 0.5,
        roughness: 0.3,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
    },
  },
  white_brick_buildings: {
    id: 'white_brick_buildings',
    prevId: '6c426eed-bf14-4183-b933-519c7eeb41c9',
    materials: {
      '0': {
        id: '0',
        emission: 0,
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        tint: '#FFF7EE',
        transparency: 1,
      },
      '1': {
        id: '1',
        emission: 0,
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        tint: '#81411E',
        transparency: 1,
      },
      '2': {
        id: '2',
        emission: 0,
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        tint: '#A44E1F',
        transparency: 1,
      },
      '3': {
        id: '3',
        emission: 0,
        metalness: 0.1,
        roughness: 0.75,
        specular: 0.5,
        tint: '#7BACC0',
        transparency: 0.5,
      },
    },
    name: 'White Brick Buildings',
  },
  furniture: {
    id: 'furniture',
    prevId: '6d6a7af9-2838-4eac-9e72-5be5f9b67ca4',
    name: 'Furniture',
    materials: {
      '0': {
        id: '0',
        tint: '#593128',
        metalness: 0,
        roughness: 0.45,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#804C35',
        metalness: 0,
        roughness: 0.45,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#F5EEE5',
        metalness: 0,
        roughness: 1,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#E5EAF0',
        metalness: 0,
        roughness: 1,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
    },
  },
  brown_brick_buildings: {
    id: 'brown_brick_buildings',
    prevId: '826fa5bf-0018-45f0-85c8-79bdfaaff247',
    materials: {
      '0': {
        id: '0',
        emission: 0,
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        tint: '#742C05',
        transparency: 1,
      },
      '1': {
        id: '1',
        emission: 0,
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        tint: '#9A3B07',
        transparency: 1,
      },
      '2': {
        id: '2',
        emission: 0,
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        tint: '#FFF7EE',
        transparency: 1,
      },
      '3': {
        id: '3',
        emission: 0,
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        tint: '#7BACC0',
        transparency: 0.5,
      },
    },
    name: 'Brown Brick Buildings',
  },
  forest: {
    id: 'forest',
    prevId: '834121dd-1832-4d2e-891d-f98f957571fa',
    name: 'Forest',
    materials: {
      '0': {
        id: '0',
        tint: '#724D25',
        metalness: 0,
        roughness: 0.8,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#80572D',
        metalness: 0,
        roughness: 0.8,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#747858',
        metalness: 0,
        roughness: 0.5,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#909567',
        metalness: 0,
        roughness: 0.5,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
    },
  },
  medieval_weapons: {
    id: 'medieval_weapons',
    prevId: '86bb4405-dc45-416c-ac1d-33eeffe26129',
    name: 'Medieval weapons',
    materials: {
      '0': {
        id: '0',
        tint: '#6B4A29',
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#B9B9B9',
        metalness: 1,
        roughness: 0.3,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#865F37',
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#DBDBDB',
        metalness: 1,
        roughness: 0.3,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
    },
  },
  stonehenge: {
    id: 'stonehenge',
    prevId: '893528be-05a7-4565-9156-2afb36519266',
    name: 'Stonehenge',
    materials: {
      '0': {
        id: '0',
        tint: '#C3C6C5',
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#9FA1A1',
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#7A7C7B',
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#6C6C6C',
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
    },
  },
  buildings_sandstone: {
    id: 'buildings_sandstone',
    prevId: '98e4d0f4-1cea-4c1f-b26f-a1b5fbdf68c0',
    name: 'Buildings Sandstone',
    materials: {
      '0': {
        id: '0',
        tint: '#967B62',
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#BF9B7A',
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#6D1D00',
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#7BACC0',
        metalness: 0,
        roughness: 0.4,
        specular: 0.5,
        emission: 0,
        transparency: 0.5,
      },
    },
  },
  'sci-fi_light_radiant_red': {
    id: 'sci-fi_light_radiant_red',
    prevId: 'a363bb42-f00a-4e3f-954d-1b66f2dcd15d',
    name: 'Sci-fi light Radiant Red',
    materials: {
      '0': {
        id: '0',
        tint: '#818181',
        metalness: 0,
        roughness: 0.65,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#C8C8C8',
        metalness: 1,
        roughness: 0.65,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#222222',
        metalness: 1,
        roughness: 0.3,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#AD2837',
        metalness: 1,
        roughness: 0.75,
        specular: 0.5,
        emission: 1,
        transparency: 0.8,
      },
    },
  },
  toy_weapons: {
    id: 'toy_weapons',
    prevId: 'a425729e-59b7-4d4c-8371-4281a153d401',
    name: 'Toy Weapons',
    materials: {
      '0': {
        id: '0',
        tint: '#169237',
        metalness: 0,
        roughness: 0.5,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#919191',
        metalness: 0,
        roughness: 0.5,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#222222',
        metalness: 0,
        roughness: 0.5,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#A6A6A6',
        metalness: 0,
        roughness: 0.5,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
    },
  },
  vehicles: {
    id: 'vehicles',
    prevId: 'ceee72f1-7a9f-4290-88ad-bcb3e1cb9b75',
    materials: {
      '0': {
        id: '0',
        emission: 0,
        metalness: 1,
        roughness: 0.5,
        specular: 0.5,
        tint: '#62CFFF',
        transparency: 1,
      },
      '1': {
        id: '1',
        emission: 0,
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        tint: '#222222',
        transparency: 1,
      },
      '2': {
        id: '2',
        emission: 1,
        metalness: 0,
        roughness: 0.5,
        specular: 0.5,
        tint: '#FFD046',
        transparency: 0.75,
      },
      '3': {
        id: '3',
        emission: 0,
        metalness: 0,
        roughness: 0.5,
        specular: 0.5,
        tint: '#AED3F2',
        transparency: 0.75,
      },
    },
    name: 'Vehicles',
  },
  lights: {
    id: 'lights',
    prevId: 'cf807338-a6be-454a-b4c1-258b2331711d',
    name: 'Lights',
    materials: {
      '0': {
        id: '0',
        tint: '#727272',
        metalness: 1,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#9E9fA3',
        metalness: 1,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#FFF2CC',
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        emission: 1,
        transparency: 0.8,
      },
      '3': {
        id: '3',
        tint: '#6BB7E3',
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        emission: 1,
        transparency: 0.8,
      },
    },
  },
  appliance: {
    id: 'appliance',
    prevId: 'de495c31-c3cd-497b-9c6f-446cbd6cf3e3',
    name: 'Appliance',
    materials: {
      '0': {
        id: '0',
        tint: '#FFFFFF',
        metalness: 0,
        roughness: 0.3,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#FFF7EE',
        metalness: 0,
        roughness: 0.3,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#818181',
        metalness: 1,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#C7EFFF',
        metalness: 0,
        roughness: 0.5,
        specular: 0.5,
        emission: 0,
        transparency: 0.8,
      },
    },
  },
  walnut: {
    id: 'walnut',
    prevId: 'e66a539f-8de2-4b98-bf2c-1d74dd3e53f9',
    name: 'Walnut',
    materials: {
      '0': {
        id: '0',
        tint: '#C19A6B',
        metalness: 0,
        roughness: 0.8,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#946E4A',
        metalness: 0,
        roughness: 0.8,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#B9B9B9',
        metalness: 1,
        roughness: 0.3,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#F5EEE5',
        metalness: 0,
        roughness: 1,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
    },
  },
  military: {
    id: 'military',
    prevId: 'f0b2559c-abf9-4ca4-b5a5-79000a17bf17',
    name: 'Military',
    materials: {
      '0': {
        id: '0',
        tint: '#639662',
        metalness: 1,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#7C7C7C',
        metalness: 1,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#D9CE96',
        metalness: 1,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#222222',
        metalness: 1,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
    },
  },
  buildings_city: {
    id: 'buildings_city',
    prevId: 'f0d28e0e-58cc-4a8b-b0bf-470bd384281f',
    name: 'Buildings City',
    materials: {
      '0': {
        id: '0',
        tint: '#646464',
        metalness: 1,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#616362',
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#7A7C7B',
        metalness: 0,
        roughness: 0.75,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#7BACC0',
        metalness: 0,
        roughness: 0.1,
        specular: 0.5,
        emission: 0,
        transparency: 0.5,
      },
    },
  },
  sloyd: {
    id: 'sloyd',
    prevId: 'f2c1859b-427c-48d0-8661-825b3609ce99',
    name: 'Sloyd',
    materials: {
      '0': {
        id: '0',
        tint: '#03F584',
        metalness: 0,
        roughness: 0.5,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#1b79ba',
        metalness: 0,
        roughness: 0.5,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#F15BB5',
        metalness: 0,
        roughness: 0.5,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#12234a',
        metalness: 0,
        roughness: 0.5,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
    },
  },
  'sci-fi_monochromatic': {
    id: 'sci-fi_monochromatic',
    prevId: 'f58c51e4-d845-4ee9-a319-5816e8d2561c',
    name: 'Sci-fi Monochromatic',
    materials: {
      '0': {
        id: '0',
        tint: '#5D5D5D',
        metalness: 1,
        roughness: 0.6,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '1': {
        id: '1',
        tint: '#7C7C7C',
        metalness: 1,
        roughness: 0.5,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '2': {
        id: '2',
        tint: '#919191',
        metalness: 1,
        roughness: 0.6,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
      '3': {
        id: '3',
        tint: '#A6A6A6',
        metalness: 1,
        roughness: 0.6,
        specular: 0.5,
        emission: 0,
        transparency: 1,
      },
    },
  },
};
